"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m12.83 2.057.584.394a.497.497 0 0 1 .134.694L6.3 13.837a.509.509 0 0 1-.213.177l-1.799.788-1.103 1.06-.011-.012a.49.49 0 0 1-.335.15.494.494 0 0 1-.443-.706l-.01-.004.53-1.132.02-.574-.038-1.695a.503.503 0 0 1 .086-.292L8.373 3.65l.826.56L3.9 12.026l.038 1.72.112.071 1.504-.66L12.441 3l-.993-.67v-.002L9.956 1.316l.278-.41a.5.5 0 0 1 .692-.134l.592.4.77-1.172 1.29.898-.746 1.16ZM9.663 3.371l-1.31-.845-2.2 3.238-.826-.56L8.074 1.16l2.129 1.372-.54.84Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m19.099 2.923 1.055.713a.558.558 0 0 1 .15.78L9.239 20.776a.56.56 0 0 1-.239.2l-2.78 1.22-1.708 1.646-.012-.013a.553.553 0 0 1-.378.17.555.555 0 0 1-.5-.794l-.008-.005.823-1.765.033-.938-.056-2.591a.566.566 0 0 1 .096-.328l8.226-12.163.93.629L5.54 18.06l.062 2.805.35.224L8.4 20.015 19.06 4.25l-2.869-1.94-.002.003-.93-.629.316-.467a.561.561 0 0 1 .78-.15l1.07.722L18.598 0l1.643 1.146-1.143 1.777Zm-4.454 1.783-2.164-1.399-3.467 5.117-.929-.63L12.17 1.77l3.086 1.994-.61.943Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m25.465 3.897 1.407.951a.744.744 0 0 1 .2 1.039L12.32 27.703a.748.748 0 0 1-.319.266l-3.706 1.626-2.278 2.196L6 31.773a.738.738 0 0 1-.504.227.74.74 0 0 1-.666-1.059l-.013-.006 1.099-2.353.044-1.252-.076-3.455a.754.754 0 0 1 .129-.436L16.98 7.222l1.24.838L7.387 24.08l.082 3.74.468.299 3.263-1.433L25.414 5.668l-3.825-2.587-.003.004-1.24-.838.421-.624a.749.749 0 0 1 1.04-.2l1.426.964L24.799 0l2.19 1.528-1.524 2.37Zm-5.937 2.377L16.642 4.41l-4.622 6.82-1.239-.839 5.445-8.034 4.116 2.66-.813 1.256Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m37.56 5.887 2.267 1.533a.94.94 0 0 1 .252 1.302L17.89 41.53a.934.934 0 0 1-.4.333l-5.601 2.459-3.452 3.325-.003-.003a.937.937 0 0 1-1.164.11.924.924 0 0 1-.318-1.171l-.015-.008 1.668-3.577.068-1.917-.113-5.208a.936.936 0 0 1 .16-.546L25.213 10.94l1.553 1.05L10.44 36.13l.127 5.786.873.556 5.05-2.217L38 8.448l-6.065-4.101v.002l-1.554-1.051.526-.778a.938.938 0 0 1 1.302-.252l2.302 1.558L36.866.239l2.988 2.083-2.294 3.565ZM28.99 9.25l-4.494-2.904-7.056 10.411-1.552-1.051 8.086-11.93 6.034 3.899L28.99 9.25Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m50.08 7.85 3.023 2.043a1.253 1.253 0 0 1 .335 1.736L23.855 55.373c-.132.195-.317.35-.533.444l-7.469 3.28-4.603 4.432-.003-.004a1.244 1.244 0 0 1-1.553.146c-.523-.344-.679-1.009-.423-1.56l-.02-.01 2.224-4.77.09-2.557-.15-6.943a1.249 1.249 0 0 1 .212-.728l21.991-32.517 2.071 1.401-21.768 32.187.17 7.714 1.164.741 6.732-2.956 28.68-42.409-8.086-5.468v.002l-2.072-1.4.701-1.038a1.251 1.251 0 0 1 1.736-.336l3.07 2.077L49.156.32l3.982 2.777L50.08 7.85Zm-11.426 4.484-5.992-3.87-9.41 13.88-2.068-1.402 10.78-15.906 8.047 5.198-1.357 2.1Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconPen = function IconPen(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Pen' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Pen"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconPen.sizes = [16, 24, 32, 48, 64];
IconPen.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconPen;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Pen.js
// module id = 1805
// module chunks = 0